import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState, Fragment } from 'react';
import { useAppContext } from '@at/sauron-platform-core/lib/app/app-context.hoc';
import { addZendeskChatScriptToDocument } from './add-zendesk-chat-script-to-document';
import { useLoginToZendesk } from './use-login-to-zendesk-hook';
export function ZendeskChat({ userIsSignedInOnJourney }) {
    const [zendeskChatScriptAddedToDocument, setZendeskChatScriptAddedToDocument] = useState(false);
    const { config, isUserSignedIn } = useAppContext();
    // Work out whether a user is signed in based on the App Context or whether signing in was detected by the SPA
    const userIsSignedIn = isUserSignedIn() || !userIsSignedInOnJourney ? isUserSignedIn() : userIsSignedInOnJourney;
    useEffect(() => {
        if (!zendeskChatScriptAddedToDocument) {
            // Add <Script/> Element to Document with correct Zendesk config in src
            addZendeskChatScriptToDocument(config.env);
            setZendeskChatScriptAddedToDocument(true);
        }
    }, [config.env, userIsSignedIn, zendeskChatScriptAddedToDocument]);
    useLoginToZendesk({ isUserSignedIn: userIsSignedIn });
    return _jsx(Fragment, {});
}
